import React from 'react'

type Props = {
  name: string
  image: string
  tesimonial: string
}

const TestimonialItem = ({name, image, tesimonial}: Props) => {
  return (
    <div className='block-dashed h-md-100  me-5'>
      <h3 className=' font-weight-bold font-size-5 text-dark-90'>
        <div className='symbol symbol-35px me-2'>
          <img src={image} className='mr-4 max-h-30px loaded' alt='' />
        </div>
        {name}
      </h3>
      <div className='separator separator-dashed border-gray-300 my-3'></div>
      <div className='block-body font-size-3'>{tesimonial}</div>
    </div>
  )
}

export default TestimonialItem
